<zest-title-step [mainTitle]="'Select Your EMI Plan'"></zest-title-step>
<div class="card">
  <div class="content">
    <div class="row">
      <div class="col s12 m12 l6 offset-l3">
        <div class="row">
          <div class="col s12 m12 l12">
            <div class="ribbon" *ngIf="showOfferRibbon">
              <zest-offer-ribbon [offerText]="ribbonOfferText"></zest-offer-ribbon>
            </div>
            <div class="emi-options">
              <div class="default-plans" *ngIf="recommendedOptions && recommendedOptions.length > 0">
                <span class="plans-label">SUGGESTED PLANS</span>
                <ul class="options-btn">
                  <li class="col s4 options-list" *ngFor="let option of recommendedOptions">
                    <span class="effective-msg"
                      *ngIf="option.SubventionInterestCashback && option.InterestAmount">Total Cashback
                      <span [textContent]="(option.InterestAmount | RupeeCurrencyPipe)"></span>
                    </span>
                    <input class="with-gap" name="group1" type="radio" [id]="'rd'+option.NumberOfMonths+1"
                      [checked]="emiOption && option.NumberOfMonths == emiOption.NumberOfMonths"
                      (click)="selectEmi(option)" />
                    <label class="currency" [for]="'rd' + option.NumberOfMonths+1"
                      [textContent]="(option.TotalMonthlyAmount | RupeeCurrencyPipe) + '/mo'"></label>
                    <span class="month-label" [textContent]="option.NumberOfMonths + ' months'"></span>
                    <div class="apr-label" *ngIf="(showAPR && (option.NumberOfMonths == emiOption.NumberOfMonths))" (click)="openAPRModal(option)">Know your APR</div>
                  </li>
                </ul>
              </div>
              <div class="clr"></div>
              <div class="other-plans" *ngIf="otherOptions && otherOptions.length > 0">
                <ul materialize="collapsible" class="collapsible other-plans" data-collapsible="accordion">
                  <li>
                    <div class="collapsible-header or">
                      <span class="plans-label text-blue">OTHER PLANS</span>
                      <span class="arrow"></span>
                    </div>
                    <div class="collapsible-body recommended-options">
                      <div class="options-btn">
                        <div class="col s4 no-padding" *ngFor="let option of otherOptions; let i= index">
                          <div *ngIf="i >= 3" class="margin-top-1rem"></div>
                          <span class="effective-msg"
                            *ngIf="option.SubventionInterestCashback && option.InterestAmount">
                            Total Cashback
                          <span [textContent]="(option.InterestAmount | RupeeCurrencyPipe)"></span>
                          </span>
                          <input class="with-gap" name="group1" type="radio" [id]="'rd'+option.NumberOfMonths+1"
                            [checked]="emiOption && option.NumberOfMonths == emiOption.NumberOfMonths"
                            (click)="selectEmi(option)" />
                          <label class="currency" [for]="'rd' + option.NumberOfMonths+1"
                            [textContent]="(option.TotalMonthlyAmount | RupeeCurrencyPipe) + '/mo'"></label>
                          <span class="month-label" [textContent]="option.NumberOfMonths + ' months'"></span>
                          <div class="apr-label" *ngIf="option.NumberOfMonths == emiOption.NumberOfMonths" (click)="openAPRModal(option)">Know your APR</div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div  *ngIf="merchantDetails && merchantDetails.MerchantItemId && merchantDetails.Description" class="merchant-details-container">
      <div class="merchant-details-list">
        <ul materialize="collapsible" class="collapsible" data-collapsible="accordion">
          <li>
            <div class="collapsible-header">
              <div class="question">Product Details</div>
            </div>
            <div class="collapsible-body">
              <div class="collapsible-body-row child-one"><span class="collapsible-body-row-label">Product ID</span><span [textContent]="merchantDetails.MerchantItemId"></span></div>
              <div class="collapsible-body-row child-two"><span class="collapsible-body-row-label">Description</span><span [textContent]="merchantDetails.Description"></span></div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- <p class="notes-info">
      This loan is not eligible for EMI pause (3 months moratorium) as the approval date is post 27th March 2020.
    </p> -->
    <p class="notes-info"
      *ngIf="emiOption && emiOption.SubventionInterestCashback && ((emiOption.TotalMonthlyAmount - emiOption.EffectiveEmiAmount) > 0)">
      After every EMI payment, monthly interest amount charged will be refunded as
      cashback to the registered bank account within 7 business days.
    </p>
    <div class="row center">
      <div class="col s12 m12 l12">
        <div class="margin-top--2rem center">
          <button [disabled]="!emiOption || processing" [ladda]="processing"
            [class]="processing?'btn waves-effect zest-btn processing ladda-button margin-top-2pc':'btn waves-effect zest-btn ladda-button margin-top-2pc'" (click)="confirmEMI()">SAVE AND CONTINUE</button>
        </div>
      </div>
    </div>
  </div>
</div>
<div id="aprModal" class="modal apr-modal" materialize="modal" [materializeParams]="[{dismissible: true}]">
  <div class="close-section right-align">
    <i class="material-icons" (click)="dismissModal()">close</i>
  </div>
  <div class="modal-content" *ngIf="aprModalContent" id="modalHeader">
    <div class="modal-header" [textContent]="aprModalContent?.header1"></div>
    <div class="modal-description" [textContent]="aprModalContent?.description1"></div>
    <div class="modal-header" [textContent]="aprModalContent?.header2"></div>
    <div class="modal-description" [textContent]="aprModalContent?.description2"></div>
    <div class="modal-header" [textContent]="aprModalContent?.header3"></div>
    <div class="modal-description" [textContent]="aprModalContent?.description3"></div>
    <div class="modal-header" [textContent]="aprModalContent?.header4"></div>
    <div class="modal-description" [textContent]="aprModalContent?.description4"></div>
    <div class="modal-header" [textContent]="aprModalContent?.header5"></div>
    <div class="disclaimer-box">
      <div class="disclaimer-header" [textContent]="aprModalContent?.interestHeader1"></div>
      <div class="disclaimer-description" [textContent]="aprModalContent?.interestSubheader1"></div>
    </div>
    <div class="spec">Effective monthly rate: <span [textContent]="selectedOption?.EffectiveMonthlyRate + '%'"></span></div>
    <div class="sub-spec">
      <div class="sub-spec-label" [innerHTML]="bulletText"></div>
    </div>
    <div class="disclaimer-box">
      <div class="disclaimer-header" [textContent]="aprModalContent?.interestHeader2"></div>
      <div class="disclaimer-description" [textContent]="aprModalContent?.interestSubheader2"></div>
    </div>
    <div class="spec">Interest rate for this loan: <span [textContent]="selectedOption?.InterestRate + '%'"></span></div>
    <div class="sub-spec"></div>
    <div class="disclaimer-box">
      <div class="disclaimer-header" [textContent]="aprModalContent?.interestHeader3"></div>
      <div class="disclaimer-description" [textContent]="aprModalContent?.interestSubheader3"></div>
    </div>
    <div class="spec">Annual percentage rate for this loan: <span [textContent]="selectedOption?.AnnualPercentageRate + '%'"></span></div>
    <div class="sub-spec">
      <div class="sub-spec-label" [innerHTML]="aprModalContent?.bulletPoint2"></div>
    </div>
    <div class="footer-note">
      <div class="modal-description" [innerHTML]="footerNote"></div>
    </div>
  </div>
  <div class="modal-footer" *ngIf="aprModalContent">
    <button class="zest-btn btn waves-effect" (click)="dismissModal()">Got it</button>
  </div>
</div>